module.exports = __webpack_public_path__ + "img/login.ac2b16e6.gif";